<template>
    <div class="sc__analysis__tab__box tab-content">
        <div class="sc__analysis__head__box">
            <div class="title__box">
                <div class="head__title__group">
                    <h3 class="title">Skills Preferences Match-Up</h3>
                </div>
                <div class="print__data__btn">
                    <WorkpacketPdf :button-label="`Download`" :assessmentId="assessmentId"
                        :organizationId="organizationId" :learnerId="learnerId"
                        v-if="assessmentId && organizationId && learnerId" />
                </div>
            </div>

            <div class="head__label__box__wrapper main__head__info__wrapper">
                <div class="head__information__wrapper">
                    <p>Speech skills can be matched with preferences that “sound like” syllables the learner can echo.
                        Info sources: EESA - R test results, Syllable Tracker (In EESA guide, Chapter 4 and Appendix A)
                    </p>
                </div>
                <div class="head__information__wrapper">
                    <h6 class="info__title">Directions</h6>
                    <ul>
                        <li>Write any syllable combinations from Syllable Tracker (Task 3) that “Sound Like” Preferred
                            items on preference list above.</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="skills__preferences__input__wrapper">
            <div class="data__cover__group__box">
                <div class="group__wrapper" v-for="(group, index) in skills_preferences_matchup" :key="index">
                    <div class="field__number">{{ index + 1 }}.</div>
                    <div class="input__group__box">
                        <div class="input__field__box">
                            <label>Syllable Combo</label>
                            <div class="input__field">
                                <input v-model="group.sc" type="text" placeholder="Type Here..." />
                            </div>
                        </div>
                        <div class="input__field__box">
                            <label>Sounds Like</label>
                            <div class="input__field">
                                <input v-model="group.sl" type="text" placeholder="Type Here..." />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section__btn__block">
            <button class="purple__save__btn" @click="saveNote">Save</button>
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import api from '@/services/axios';
import { useLoaderStore } from '@/stores/loader';
import { handleError } from '@/utils/handleError';
import { showDialog } from '@/utils/swal';
import WorkpacketPdf from './WorkpacketPdf.vue';
import { authrizedPermissions } from '@/utils/permissions';

const props = defineProps({
    organizationId: Number,
    assessmentId: Number,
    learnerId: Number,
    canConductAssessment: Boolean,
});

const loader = useLoaderStore();

const initNote = [
    { "sc": "", "sl": "" },
    { "sc": "", "sl": "" },
    { "sc": "", "sl": "" },
    { "sc": "", "sl": "" },
    { "sc": "", "sl": "" },
    { "sc": "", "sl": "" },
    { "sc": "", "sl": "" }
];
const skills_preferences_matchup = ref(initNote);
const assessment = ref(null);

const fetchAssessment = async () => {
    loader.show();
    try {
        const { data } = await api.get(`/organizations/${props.organizationId}/assessments/${props.assessmentId}`);
        assessment.value = data?.data || null
        const note = data?.data?.note?.skills_preferences_matchup;

        skills_preferences_matchup.value = (note) ? JSON.parse(note) : initNote;
    } catch (error) {
        console.log(error);

        handleError(error);
    } finally {
        loader.hide();
    }
};

const saveNote = async () => {
    if (!props.canConductAssessment) {
        let message = `You don’t have permission perform this action.`;
        const learner = assessment.value?.learner;
        if (learner?.is_administrator) {
            message = `You don’t have permission perform this action because it was created before you were granted administrator access.`;
        } else if (learner?.is_authorized_user) {
            if (learner?.permissions?.[authrizedPermissions.conduct_view_assessments]) {
                message = `You don’t have permission perform this action because it was created before you were granted group access.`;
            } else if (!learner?.permissions?.[authrizedPermissions.conduct_view_assessments]) {
                message = `You don’t have permission perform this action.`;
            }
        }

        showDialog({ icon: 'warning', html: message });
        return;
    }

    loader.show();
    try {
        await api.post(`/organizations/${props.organizationId}/assessments/${props.assessmentId}/notes`, {
            skills_preferences_matchup: JSON.stringify(skills_preferences_matchup.value)
        });

        showDialog({
            title: 'Success',
            icon: 'success',
            html: 'Note saved successfully!'
        });
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
}

onMounted(fetchAssessment);
</script>